import { createSvgIcon } from 'shared/icons/IconUtils';

export const CheckCircleIcon = createSvgIcon(
  'CheckCircleIcon',
  <path
    d="M8.00037 1.33337C11.6821 1.33355 14.6664 4.31858 14.6664 8.00037C14.6662 11.682 11.682 14.6662 8.00037 14.6664C4.31858 14.6664 1.33355 11.6821 1.33337 8.00037C1.33337 4.31847 4.31847 1.33337 8.00037 1.33337ZM6.92029 8.8949L5.51599 7.51306L4.64001 8.36853L6.92029 10.6117L11.3588 6.24548L10.4877 5.38806L6.92029 8.8949Z"
    fill="currentColor"
  />,
  { viewBox: '0 0 16 16' },
);
